webpackJsonp([35783957827783],{

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeHelmet = function HomeHelmet(props) {
	  var url = "https://www.javascriptstuff.com" + props.path;
	  var name = "JavaScript Stuff";
	  var description = props.description;
	  var metaImagePath = "https://www.javascriptstuff.com/meta-home.png";
	
	  return _react2.default.createElement(
	    _reactHelmet.Helmet,
	    null,
	    _react2.default.createElement(
	      "title",
	      null,
	      name
	    ),
	    _react2.default.createElement("meta", { name: "title", content: name }),
	    _react2.default.createElement("meta", { name: "description", content: description }),
	    _react2.default.createElement("meta", { itemProp: "title", content: name }),
	    _react2.default.createElement("meta", { itemProp: "description", content: description }),
	    _react2.default.createElement("meta", { itemProp: "image", content: metaImagePath }),
	    _react2.default.createElement("meta", { name: "twitter:card", content: "summary" }),
	    _react2.default.createElement("meta", { name: "twitter:site", content: "@ahfarmer" }),
	    _react2.default.createElement("meta", { name: "twitter:creator", content: "@ahfarmer" }),
	    _react2.default.createElement("meta", { name: "twitter:title", content: name }),
	    _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	    _react2.default.createElement("meta", { name: "twitter:image", content: metaImagePath }),
	    _react2.default.createElement("meta", { name: "og:title", content: name }),
	    _react2.default.createElement("meta", { name: "og:type", content: "article" }),
	    _react2.default.createElement("meta", { name: "og:url", content: url }),
	    _react2.default.createElement("meta", { name: "og:description", content: description }),
	    _react2.default.createElement("meta", { name: "og:site_name", content: "JavaScript Stuff" }),
	    _react2.default.createElement("meta", { name: "og:image", content: metaImagePath })
	  );
	};
	HomeHelmet.propTypes = {
	  path: _propTypes2.default.string,
	  description: _propTypes2.default.string
	};
	HomeHelmet.defaultProps = {
	  path: "/",
	  description: "Helping you find & learn modern JS tools w/ lists, guides, and articles."
	};
	exports.default = HomeHelmet;
	module.exports = exports["default"];

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  title: "CSS Modules by Example",
	  path: "/css-modules-by-example",
	  subtitle: "CSS Modules are super trendy and super useful. Learn how they work, visually, by example",
	  date: new Date(2016, 3, 27),
	  update_date: new Date(2018, 0, 14)
	};
	module.exports = exports["default"];

/***/ }),

/***/ 76:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  title: "What to use for React styling?",
	  path: "/how-to-style-react",
	  subtitle: "High level overview of all the tools available for styling React components, and how they fit together. Covers PostCSS, Sass, BEM, CSS Modules, Autoprefixer, cssnext, and more.",
	  date: new Date(2016, 3, 14)
	};
	module.exports = exports["default"];

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [__webpack_require__(75), __webpack_require__(76)];
	module.exports = exports["default"];

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // The 'guides' are articles that have been built in React
	// For now I have articles and guides all mixed together.
	
	
	exports.default = getArticlesAndGuides;
	
	var _sortBy = __webpack_require__(317);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _guides = __webpack_require__(165);
	
	var _guides2 = _interopRequireDefault(_guides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getArticlesAndGuides(data) {
	  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var unsorted = data.allMarkdownRemark.edges.map(function (edge) {
	    return _extends({}, edge.node.frontmatter, {
	      date: new Date(edge.node.frontmatter.date)
	    });
	  }).filter(function (x) {
	    return !x.archive;
	  }).concat(_guides2.default);
	
	  var sorted = (0, _sortBy2.default)(unsorted, function (x) {
	    return x.date.getTime();
	  }).reverse();
	  if (limit) {
	    return sorted.slice(0, limit);
	  }
	  return sorted;
	}
	module.exports = exports["default"];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CenterContent = __webpack_require__(17);
	
	var _CenterContent2 = _interopRequireDefault(_CenterContent);
	
	var _HomeHelmet = __webpack_require__(160);
	
	var _HomeHelmet2 = _interopRequireDefault(_HomeHelmet);
	
	var _Link = __webpack_require__(34);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Page = __webpack_require__(10);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _PrettyLink = __webpack_require__(123);
	
	var _PrettyLink2 = _interopRequireDefault(_PrettyLink);
	
	var _indexModule = __webpack_require__(656);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _getArticlesAndGuides = __webpack_require__(166);
	
	var _getArticlesAndGuides2 = _interopRequireDefault(_getArticlesAndGuides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderArticle = function (article) {
	      return _react2.default.createElement(
	        "li",
	        { key: article.path, className: _indexModule2.default.articleLink },
	        _react2.default.createElement(
	          _PrettyLink2.default,
	          { to: article.path },
	          article.title
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.render = function render() {
	    // for now guides and articles are all mixed together
	    var articles = (0, _getArticlesAndGuides2.default)(this.props.data, 5);
	
	    return _react2.default.createElement(
	      _Page2.default,
	      null,
	      _react2.default.createElement(_HomeHelmet2.default, null),
	      _react2.default.createElement(
	        _CenterContent2.default,
	        { className: _indexModule2.default.content },
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Learn the Latest JavaScript Tools"
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Build apps faster and have more fun doing it \uD83C\uDF89"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Where to begin?"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              "Searching for a tool, starter project, or library? Go to the",
	              " ",
	              _react2.default.createElement(
	                _PrettyLink2.default,
	                { to: "/lists/" },
	                "lists"
	              ),
	              "."
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              "Looking for help with React, Webpack, CSS Modules or other tools? Go to the",
	              " ",
	              _react2.default.createElement(
	                _PrettyLink2.default,
	                { to: "/articles/" },
	                "articles"
	              ),
	              "."
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "span",
	              null,
	              "Absolute beginner to React and trying to get started? Read about building a",
	              " ",
	              _react2.default.createElement(
	                _PrettyLink2.default,
	                { to: "/tiny-unique-app/" },
	                "tiny app"
	              ),
	              "."
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Latest Articles"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          articles.map(this.renderArticle)
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.allArticlesCenter },
	          _react2.default.createElement(
	            _Link2.default,
	            { className: _indexModule2.default.allArticlesLink, to: "/articles/" },
	            "All Articles"
	          )
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"content":"src-pages----index-module---content---30-nr","articleLink":"src-pages----index-module---articleLink---2viq-","allArticlesCenter":"src-pages----index-module---allArticlesCenter---3uNSl","allArticlesLink":"src-pages----index-module---allArticlesLink---2o7Qe"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f9f904261e9a75e74de6.js